import Vue from 'vue';
import Router from 'vue-router';
import VueGtm from '@gtm-support/vue2-gtm';

Vue.use(Router);


Vue.use(VueGtm, {
  id: 'GTM-K2KTV9P', // Your GTM single container ID, array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy'] or array of objects [{id: 'GTM-xxxxxx', queryParams: { gtm_auth: 'abc123', gtm_preview: 'env-4', gtm_cookies_win: 'x'}}, {id: 'GTM-yyyyyy', queryParams: {gtm_auth: 'abc234', gtm_preview: 'env-5', gtm_cookies_win: 'x'}}], // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  defer: true, // Script can be set to `defer` to speed up page load at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible). Defaults to false, so the script is loaded `async` by default
  compatibility: false, // Will add `async` and `defer` to the script tag to not block requests for old browsers that do not support `async`
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});


export default new Router({
  mode: "history",
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: "/",
      name: 'Home',
      component: () => import('@/view/pages/home/Home.vue'),
    },
    {
      path: '/terms-conditions',
      name: 'Terms',
      component: () => import('@/view/pages/Terms.vue')
    },
    {
      path: '/privacy-policy',
      name: 'Privacy',
      component: () => import('@/view/pages/Privacy.vue')
    },
    {
      path: '/disclaimer',
      name: 'Disclaimer',
      component: () => import('@/view/pages/Disclaimer.vue')
    },
    {
      path: "*",
      name: 'StartPage',
      component: () => import('@/view/pages/home/components/HomeStartPage.vue'),
      meta: {
        layout: 'empty'
      }
    },
    // {
    //   path: "/:language/:offer",
    //   name: 'Offer',
    //   component: () => import('@/view/pages/Offer.vue')
    // },
  ]
});
